import {
  getServerTime,
  postTrolleyList,
  postCouponChopCartDisInOrder
} from '@/api/shoppingCar';
import { countDiscount } from '@/utils/countDiscount';

const actions = {
  // 获取有效商品列表
  async acTrolleyList({ commit, state, rootState, rootGetters }, params) {
    let res = await postTrolleyList(params);
    commit('muTrolleyList', res);
    return res;
  },
  // 获取购物车优惠推荐
  async acCartDisInOrder({ commit }, params) {
    const res = await postCouponChopCartDisInOrder(params);
    res.data =  countDiscount(res.data);
    return res;
  },
};
export default actions;
